<template>
  <div id="boxes-by-partner-screen">
    <template v-if="isLoading">
      <div class="loading-screen">
        <loader-ring />
      </div>
    </template>
    <template v-else>
      <div class="filter">
        <boxes-by-partner-filter @clickedFilter="clickedFilter" />
      </div>
      <template v-if="boxesByPartner.length === 0">
        <div class="empty-state">
          <h5
            class="text"
            v-if="response === undefined"
            v-html="$t('movementsScreen.emptyState')"
          ></h5>
          <h5
            class="text"
            v-if="response !== undefined"
            v-html="$t('movementsScreen.noResponse')"
          ></h5>
        </div>
      </template>
      <template v-if="boxesByPartner.length !== 0">
        <div class="movements-wrapper">
          <div class="movements">
            <div
              class="movement-item-wrapper"
              v-for="(item, index) in boxesByPartner"
              :key="index"
            >
              <boxes-by-partner-groups
                class="movement-group-wrapper"
                :group="item"
              />
              <div
                class="divider"
                v-if="index !== boxesByPartner.length - 1"
              ></div>
            </div>
          </div>
        </div>
        <div class="show-more-button">
          <rounded-button
            :isOutline="true"
            class="button"
            position="center"
            v-if="hasMorePage"
            :loading="loadingShowMore"
            @click="showMore"
          >
            {{ $t("storeScreen.boxOverlay.showMore") }}
          </rounded-button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import BoxesByPartnerFilter from "@/components/modules/BoxesByPartner/BoxesByPartnerFilter";
import BoxesByPartnerGroups from "@/components/modules/BoxesByPartner/BoxesByPartnerGroups";
import { mapActions } from "vuex";
export default {
  name: "BoxesByPartnerScreen",
  props: {},
  components: {
    BoxesByPartnerGroups,
    BoxesByPartnerFilter
  },
  data: () => ({
    boxesByPartner: [],
    currentPage: 0,
    response: undefined,
    filter: undefined,
    isLoading: false,
    loadingShowMore: false
  }),
  created() {
    this.isLoading = true;
    this.getBoxes(true);
  },
  computed: {
    computedData() {
      return { page: this.currentPage + 1, ...this.filter };
    },
    hasMorePage() {
      if (this.response) {
        return this.response.total > this.currentPage * this.response.per_page;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions({
      readBoxesByPartner: "boxes/readBoxesByPartner"
    }),
    clickedFilter(filter) {
      this.currentPage = 0;
      this.filter = filter;
      this.getBoxes(true);
    },
    showMore() {
      this.loadingShowMore = true;
      this.getBoxes(false);
    },
    getBoxes(init) {
      this.readBoxesByPartner(this.computedData)
        .then(res => {
          if (res.status === "OK") {
            this.response = res.data;
            if (init) {
              this.boxesByPartner = res.data.data;
            } else {
              this.boxesByPartner.push(...res.data.data);
            }
            this.isLoading = false;
            this.loadingShowMore = false;
            this.currentPage += 1;
          } else {
            this.isLoading = false;
            this.loadingShowMore = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.loadingShowMore = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#boxes-by-partner-screen {
  padding-top: 20px;
  padding-bottom: 20px;
  height: 100%;
  .empty-state {
    margin-top: 40px;
  }
  .filter {
    margin-bottom: 30px;
  }
  .movements-wrapper {
    overflow: auto;
    .movements {
      width: fit-content;
      min-width: 100%;
      .movement-item-wrapper {
        min-width: 100%;
        width: fit-content;
        .movement-group-wrapper {
          margin-top: 10px;
          margin-bottom: 10px;
        }
        &:first-child {
          .movement-group-wrapper {
            margin-top: 0;
          }
        }
        &:last-child {
          .movement-group-wrapper {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .show-more-button {
    padding-bottom: 20px;
    margin: 20px auto 0 auto;
    max-width: 300px;
  }
}
.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
